import { inject } from '@angular/core';
import { switchMap } from 'rxjs';
import { environment } from '@environments/environment';
import { AuthService } from '@shared/services/auth.service';
import type { HttpInterceptorFn } from '@angular/common/http';
import { BYPASS_TOKEN } from '../context/auth-context';

export const targetHostInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const refreshTokenPath = '/auth/refresh-token';

  if (req.context.get(BYPASS_TOKEN)) {
    return next(req);
  }

  if (authService.isTokenExpired()) {
    authService.logout();
    return next(req);
  }

  return authService.refreshToken().pipe(
    switchMap(() => {
      const token = sessionStorage.getItem('token');
      const sk = sessionStorage.getItem('sk');

      if (!token || !sk) {
        return next(req);
      }

      const authHeaders = {
        Authorization: `Bearer ${token}`,
        SK: sk,
      };

      if (req.url.includes(refreshTokenPath)) {
        return next(req);
      }

      const targetHostHeaders: Record<string, string> = environment.targetHost
        ? {
            'ngrok-skip-browser-warning': 'false',
            'X-Target-Host': environment.targetHost,
          }
        : {};

      if (!Object.keys(targetHostHeaders).length) {
        return next(req.clone({ setHeaders: authHeaders }));
      }

      return next(
        req.clone({
          setHeaders: {
            ...authHeaders,
            ...targetHostHeaders,
          },
        }),
      );
    }),
  );
};
